export var testIds;
(function (testIds) {
    testIds["loadingSpinner"] = "SignupTeamLoadingSpinner";
    testIds["title"] = "SignupTeamPageTitle";
    testIds["companyNameField"] = "SignupTeamCompanyNameField";
    testIds["button"] = "SignupTeamSubmitButton";
    testIds["pollingText"] = "SignupTeamPollingText";
    testIds["legalTermCheckbox"] = "CreateTeamLegalTermCheckbox";
})(testIds || (testIds = {}));
